import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateAccountPassword } from '../../api';

export function useUpdateAccountPassword() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ accountId, password }: { accountId: number; password: string }) =>
      updateAccountPassword(accountId, password),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['accounts'] }),
  });
}
